import styled from 'vue-styled-components';

const Label = styled.div`
    color: ${props => props.color};
`;

export { Label };
